import { Api } from '@/munio/api/base'
import { URLParams } from '@/munio/http'
import { CollectionResponse, ResourceResponse, RoleResourceDto } from '@/munio/api/data'
import { Translation } from '@/munio/definitions'

export default class Roles extends Api {
  get(options: URLParams) {
    return this.$get<CollectionResponse<RoleResourceDto>>(this.$route('api.web.admin.roles'), this.$query(options))
  }

  create(name: Translation) {
    return this.$post<ResourceResponse<RoleResourceDto>>(this.$route('api.web.admin.role.create'), { name })
  }
}
